import React from "react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-border bg-card">
      <div className="mx-auto max-w-7xl px-5 py-6 text-center text-sm text-muted-foreground">
        Core-emotion.com is een initiatief van TIOUW.com BV, Binderij 7-L, 1185 ZH Amstelveen, Nederland.
      </div>
    </footer>
  );
}
